module.exports = __webpack_public_path__ + "img/x1.6f042d3d.png";